const shifts = {
  toast: {
    error: {
      badResponse: '[Rate] Schlechte Serverantwort',
    },
  },

  create: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Schicht konnte nicht erstellt werden',
    },
    successToast: {
      message: 'Erfolg! Schicht erfolgreich erstellt,Success!',
    },
  },

  delete: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Die Schicht konnte nicht gelöscht werden.',
    },
    successToast: {
      message: 'Erfolg! Schichten erfolgreich gelöscht.',
    },
    confirmation: {
      header: 'Schichtlöschbestätigung',
      body: {
        dynamic: 'Sie sind dabei, {{numShifts}} Schichten zu löschen.',
        all: 'Sie sind dabei, alle Schichten zu löschen.',
      },
    },
  },

  edit: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Die Schicht konnte nicht aktualisiert werden.',
    },
    successToast: {
      message: 'Erfolg! Schicht erfolgreich aktualisiert',
    },
  },

  headerButtons: {
    create: 'Erstellen',
  },

  table: {
    headers: {
      name: 'Name',
      status: 'Status',
      start: 'Starten',
      end: 'Ende',
      year: 'Jahr',
      direction: 'Richtung',
      weekDays: 'Wochentage',
    },
    cells: {
      direction: {
        collect: 'Sammeln',
        distribute: 'Verteilen',
        both: 'Sammeln/Verteilen',
      },
      weekDays: {
        weekDaysOptions: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      },
      status: {
        statusOptions: {
          statusActive: 'Aktiv',
          statusNotActive: 'Nicht aktiv',
        },
      },
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },

  form: {
    header: {
      createShift: {
        title: 'Erstellen',
      },

      updateShift: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      details: {
        header: 'Schicht',
        fields: {
          name: 'Name',
          status: 'Status',
          start: 'Starten',
          end: 'Ende',
          year: 'Jahr',
          direction: 'Richtung',
          weekDays: 'Wochentage',
        },
      },
      directionOptions: {
        selectDirection: 'Richtung auswählen',
        collect: 'Sammeln',
        distribute: 'Verteilen',
        both: 'Sammeln/Verteilen',
      },
    },
    validations: {
      name: {
        required: 'Name ist erforderlich',
        name: '',
      },
      start: {
        required: 'Start ist erforderlich',
        start: '',
      },
      end: {
        required: 'Ende ist erforderlich',
        end: '',
      },
      year: {
        required: 'Jahr ist erforderlich',
        year: '',
      },
      direction: {
        required: 'Richtung ist erforderlich',
        direction: '',
      },
      weekDays: {
        required: 'Sie müssen mindestens einen Tag auswählen',
        weekDays: '',
      },
    },
    notification: {
      overnight: 'meaning the pickup will be on the following day,Die Endzeit liegt vor der Startzeit, d. h. die Abholung erfolgt am nächsten Tag, meaning the pickup will be on the following day',
    },
  },
};

export default shifts;
